<!-- Быстрое создание пометки по ТС с главной страницы. -->
<template>
  <HomeQuickActionCard
    label="Сделать пометку по ТС"
    description="Поломка, ошибка, замечание по машине"
    icon-name="info"
    color="red"
    :list-to="{ name: 'Fleet' }"
    list-label="Открыть автопарк"
    list-subject="автопарк"
    @click="openModal"
  />

  <Teleport to="body">
    <BaseModal
      :visible="showModal"
      title="Сделать пометку по ТС"
      size="lg"
      footer-align="start"
      elevated-footer
      adaptive-fullscreen
      @close="closeModal"
    >
      <div class="vehicle-problem-action__form">
        <BaseFormField
          label="Автопарк"
          for-id="home-vehicle-remark-fleet-park"
          wide
          :filled="Boolean(fleetParkId)"
        >
          <FleetParkSelect
            id="home-vehicle-remark-fleet-park"
            :model-value="fleetParkId"
            placeholder="Все автопарки"
            :with-button="false"
            @update:modelValue="handleFleetParkChange"
          />
        </BaseFormField>

        <BaseFormField
          label="Транспорт"
          for-id="home-vehicle-remark-vehicle"
          required
          wide
          :filled="Boolean(vehicleId)"
          :error="errors.vehicle_id"
          error-message="Выберите транспорт"
        >
          <VehicleSelect
            id="home-vehicle-remark-vehicle"
            v-model="vehicleId"
            placeholder="Выберите транспорт"
            :clearable="false"
            :fleet-park-id="fleetParkId"
            @update:modelValue="errors.vehicle_id = false"
          />
        </BaseFormField>

        <VehicleRemarkForm
          :vehicle-id="vehicleId"
          v-if="showModal"
          :form-id="formId"
          :is-submitting="store.isSubmitting"
          @submit="createRemark"
        />
      </div>

      <template #footer>
        <base-primary-button
          type="submit"
          :form="formId"
          :disabled="store.isSubmitting"
        >
          <span v-if="store.isSubmitting">Сохранение...</span>
          <span v-else>Сообщить</span>
        </base-primary-button>

        <base-button
          type="button"
          :disabled="store.isSubmitting"
          @click="closeModal"
        >
          Отмена
        </base-button>
      </template>
    </BaseModal>
  </Teleport>
</template>

<script>
import HomeQuickActionCard from "@/components/Home/QuickActionCard.vue";
import FleetParkSelect from "@/components/Vehicle/FleetParkSelect.vue";
import VehicleRemarkForm from "@/components/Vehicle/Remark/Form/Form.vue";
import VehicleSelect from "@/components/Vehicle/VehicleSelect.vue";

import { useFleetVehicleRemarkStore } from "@/stores/fleetVehicleRemarkStore";
import { getSelectedFleetParkId } from "@/utils/fleetParkStorageUtils";

export default {
  name: "HomeVehicleProblemAction",

  components: {
    FleetParkSelect,
    HomeQuickActionCard,
    VehicleRemarkForm,
    VehicleSelect,
  },

  data() {
    return {
      showModal: false,
      fleetParkId: null,
      vehicleId: null,
      errors: {
        vehicle_id: false,
      },
    };
  },

  computed: {
    store() {
      return useFleetVehicleRemarkStore();
    },

    formId() {
      return "home-vehicle-remark-form";
    },
  },

  methods: {
    openModal() {
      this.fleetParkId = getSelectedFleetParkId();
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.fleetParkId = null;
      this.vehicleId = null;
      this.errors.vehicle_id = false;
    },

    handleFleetParkChange(value) {
      this.fleetParkId = value;
      this.vehicleId = null;
      this.errors.vehicle_id = false;
    },

    async createRemark(payload) {
      if (this.store.isSubmitting) return;
      if (!this.vehicleId) {
        this.errors.vehicle_id = true;
        return;
      }

      await this.store.createRemark(this.vehicleId, payload);
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.vehicle-problem-action__form {
  display: grid;
  gap: 0;
}
</style>
